export default status => {
  if (status === 'NOT_REDEEMED') {
    return '#595959';
  } if (status === 'PARTIALLY_REDEEMED') {
    return '#D17621';
  } if (status === 'REDEEMED') {
    return '#099075';
  } return '#595959';
};
